import { StrictMode } from "react"

import { QueryClientProvider } from "@tanstack/react-query"

import { IDirective } from "angular"
import { createRoot } from "react-dom/client"

import { queryClient } from "@/query/queryClient"

import { SubscriptionFinancialAid } from "./SubscriptionFinancialAid"
import { SubscriptionFinancialAidController } from "./SubscriptionFinancialAid.controller"

export function SubscriptionFinancialAidDirective(): IDirective {
  return {
    restrict: "E",
    controller: "SubscriptionFinancialAidController",
    link: function (scope, element, _attributes, controller) {
      const root = createRoot(element[0])

      root.render(
        <StrictMode>
          <QueryClientProvider client={queryClient}>
            <SubscriptionFinancialAid
              controller={controller as SubscriptionFinancialAidController}
            />
          </QueryClientProvider>
        </StrictMode>,
      )

      // Clean up React component when the Angular component is destroyed
      scope.$on("$destroy", () => {
        root.unmount()
      })
    },
  }
}
